import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import PromoSection from "../components/PromoSection";
import AboutShow from "../components/AboutShow";
import Marquee from "../components/Marquee";
import AboutPianist from "../components/AboutPianist";
import Gallery from "../components/Gallery";
import TourDates from "../components/TourDates";
import AboutVenue from "../components/AboutVenue";
import Testimonials from "../components/Testimonials";
import BookingSection from "../components/BookingSection";
import Footer from "../components/Footer";

export default function LandingPage() {
  const [showPromoPopup, setShowPromoPopup] = useState(false);
  const [promoActivated, setPromoActivated] = useState(false);

  const handleShowPromo = () => {
    // Yandex Metrica — событие при успешной отправке формы
    if (typeof window.ym === "function") {
      window.ym(109083162, "reachGoal", "lead_capture_success");
    }
    setShowPromoPopup(true);
    setPromoActivated(true);
  };
  const handleClosePromo = () => setShowPromoPopup(false);

  return (
    <main className="noise-overlay" data-testid="landing-page">
      <Navbar />
      <Hero />
      <PromoSection visible={showPromoPopup} onClose={handleClosePromo} showMinimized={promoActivated} />
      <AboutShow />
      <Marquee />
      <AboutPianist />
      <Gallery />
      <AboutVenue />
      <BookingSection onSuccess={handleShowPromo} />
      <TourDates />
      <Testimonials />
      <Footer />
    </main>
  );
}
